import { CircularProgress, LinearProgress, Stack } from "@mui/material";

const Loading = () => {
    return <>
        <LinearProgress />
    </>
}

export default Loading;
